<template>
    <div class="bg-main-black">
        <header class="container mx-auto">
            <navigation-menu></navigation-menu>
            <div class="pt-16 lg:flex items-center">
                <div class="lg:w-1/2 text-center">
                    <img src="./../assets/phonesQR.png" alt="iphones image" class="xl:h-iphones lg:h-100 md:h-100 sm:h-100 xs:h-100">
                </div>
    
                <div class="w-auto xs:m-0 md:m-1 md:pl-24 md:pr-24" id="content">
                    <h2 class="text-white font-black lg:text-4xl md:text-3xl sm:text-xl xs:text-lg mb-4 lg:w-4/5 text-center">
                        IBESTICA
                    </h2>
                    <div class="text-grey-light opacity-50 mb-4 text-justify lg:w-4/5 md:text-md sm:text-sm xs:text-sm">
                        Ibestica solution provides the way to full network transparency: From Suppliers to Customers and OEMs to 3rd Logistics Providers!<br><br> Digitalize, automate and optimize your supply chain now!
                    </div>

                    <form>
                    <div class="mb-4 mt-8 w-full">
                        <span v-if="error.emailEmpty">
                            <input v-model="email" type="text" placeholder="Your email" class="w-full border border-red-light bg-grey-lightest py-4 text-main-black font-medium text-base text-center focus:bg-grey-light focus:outline-none">
                            <span class="text-white font-semibold text-xs opacity-75">
                                You need to enter your email 
                            </span>
                        </span>

                        <span v-else>
                            <span v-if="error.emailWrong">
                                <input v-model="email" type="text" placeholder="Your email" class="w-full border border-red-light bg-grey-lightest py-4 text-main-black font-medium text-base text-center focus:bg-grey-light focus:outline-none">
                                <span class="text-white font-semibold text-xs opacity-75">
                                    You should enter a valid email address
                                </span>
                            </span>
                            <span v-else>
                                <input v-model="email" type="text" placeholder="Your email" class="w-full bg-grey-lightest py-4 text-main-black font-medium text-base text-center focus:bg-grey-light focus:outline-none">
                            </span>
                        </span>
                    </div>

                    <div class="mb-4 w-full">
                        <span v-if="error.passwordEmpty">
                            <input v-model="password" type="password" placeholder="Your password" class="w-full border border-red-light bg-grey-lightest py-4 text-main-black font-medium text-base text-center focus:bg-grey-light focus:outline-none">
                            <span class="text-white font-semibold text-xs opacity-75">
                                Invalid password
                            </span>
                        </span>

                        <span v-else>
      
                            <input @keyup.enter="checkForm()" v-model="password" type="password" placeholder="Your password" autocomplete="false" class="w-full bg-grey-lightest py-4 text-main-black font-medium text-base text-center focus:bg-grey-light focus:outline-none">
                         
                        </span>
                    </div>

                    <div class="flex text-center lg:w-auto mb-4 lg:mb-0 justify-center lg:w-full">
                        
                        <a v-if="!downloading" href="#" @click="checkForm()"
                        class="flex-1 text-center verical-center justify-center text-sm px-6 py-3
                        leading-none no-underline border rounded-xl bg-main-green
                        text-grey-lightest border-black hover:border-grey-lightest
                        hover:text-grey-lightest hover:bg-transparent mt-4 mt-0 mr-0">
                            Download
                        </a>
                        
                        <!-- <span class="flex-2 inline-flex items-center justify-center text-center mt-4">
                            <img src="./../assets/play-button.svg" alt="play button" class="h-8 mr-2">
                            <a href="#" class="no-underline text-semibold text-grey-lightest text-lg opacity-50 hover:opacity-100">
                               <span class="md:text-lg sm:text-md md:block xs:hidden">Watch How it Works</span>
                             </a>
                        </span>-->
                        <div v-if="downloading">
                            <p class="font-semibold" style="color:white;">DOWNLOADING, please wait</p>
                            <p style="color:white;">... this may take up to 5min (filesize 60mb)</p>
                            <br>
                            <pulse-loader :loading="loading"></pulse-loader>
                      
                        </div>
                    </div>
                    <span v-if="apkError">
                        <span class="text-red font-semibold text-sm opacity-75">
                            Invalid credentials
                        </span>
                    </span>
                </form>


                </div>
            </div>
        </header>
    
        <svg preserveAspectRatio="xMidYMax meet" class="svg-separator sep12" viewBox="0 0 1600 200" style="display: block;" data-height="200">
          <polygon style="fill: #f8fafc;" points="-4,24 800,198 1604,24 1604,204 -4,204 "></polygon> 
       <!--  <polygon style="opacity: 1;fill: #95a5a6;" points="-4,0 800,198 1604,0 1604,11.833 800,198 -4,12 "></polygon> -->
          <polygon style="opacity: 1;fill: #dae1e7;" points="-4,12 -4,24 800,198 1604,24 1604,11.833 800,198 "></polygon>
        </svg>
    </div>
</template>

<script>
    import NavigationMenu from "./NavigationMenu";
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
    import fileDownload from 'js-file-download';

    export default {
    components: {
        NavigationMenu,
        PulseLoader
    },
    data() {
        return {
            info: null,
            loading: true,
            downloading: false,
            downloadUrl: "",
            totalSize: 62,
            error: {

                emailEmpty: false,
                emailWrong: false,
                passwordEmpty: false,
                invalidCredentials: false,

            },
            email: null,
            password: null,
            apkError: null
        };
    },

    computed: {
    hasNoErrors() {
      return (
        !this.error.nameEmpty &&
        !this.error.emailEmpty &&
        !this.error.emailWrong &&
        !this.error.invalidCredentials &&
        !this.error.passwordEmpty &&
        !this.error.messageBodyEmpty
      );
    }
  },
    methods: {
        emailValidation(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
        },

    checkForm() {
        this.error.invalidCredentials = false;
      if (!this.email) {
        this.error.emailEmpty = true;
      } else {
        if (this.emailValidation(this.email)) {
          this.error.emailWrong = false;
        } else {
          this.error.emailWrong = true;
        }
        this.error.emailEmpty = false;
      }

      if (!this.password) {
        this.error.passwordEmpty = true;
      }else{
          this.error.passwordEmpty = false;
      }

      if (this.hasNoErrors) {
        this.download();
      }
    },

    resetForm() {
    //   this.password = null;
    //   this.email = null;
      
    },
    //https://app.ibestic.com/api/dwn


    async getTheFile(url) {
        this.downloading = false
        // const res = await axios.get(url, {
        //     responseType: 'arraybuffer',
        //     headers: {
        //         'Accept': 'application/vnd.android.package-archive',
        //         'Content-Type': 'application/vnd.android.package-archive',
        //         'Content-Disposition':'attachment'
        //     }
        // })

        // const blob = new Blob([response.data], { type: 'application/vnd.android.package-archive'})
        let link = document.createElement('a')
        link.href = url
          link.download = 'ibestica.apk'
          link.target = '_blank'
          link.click()
        this.resetForm()

    },

    async download(){
        try {
        //this.downloading = true
        var error = null
        const response = await axios
            .post(
                'https://app.ibestic.com/api/dwn',
                //'http://ibestica.test:8000/api/dwn',
                 {'password': this.password, 'email': this.email },
                 {
                     headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                 },
               
            );
        console.log('url', response.data.url)
        if (response.data.url !== "") {
            await this.getTheFile(response.data.url)
            //this.resetForm();
        }
        } catch (e) {
            this.downloading = false
            this.apkError = e
        }
    
     }
  }
}

</script>